export const ContentType = {
  urlEncoded: 'application/x-www-form-urlencoded',
  json: 'application/json',
};
